<template>
  <el-container
    style="min-height: 100vh; display: flex; flex-direction: column"
  >
    <!-- 导航栏 -->
    <NavBarComp />
    <!-- 页面内容 -->
    <el-main style="flex: 1; padding: 0">
      <router-view />
    </el-main>
    <!-- 页脚 -->
    <FooterComp />
  </el-container>
</template>

<script>
// 引入公共组件
import NavBarComp from "./components/NavBarComp";
import FooterComp from "./components/FooterComp";

export default {
  name: "App",
  components: {
    NavBarComp,
    FooterComp,
  },
  methods: {
    handleNavClick(anchorId, sectionId) {
      console.log("导航点击:", anchorId, sectionId);
    },

    handleFooterScroll(sectionId) {
      // 找到对应的导航项ID
      const navItems = this.$refs.navbar.navItems || [];
      const navItem = navItems.find((item) => item.sectionId === sectionId);
      if (navItem) {
        this.$refs.navbar.scrollToAnchor(navItem.id);
      }
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  font-family: "Microsoft YaHei", sans-serif;
}
.el-main {
  padding: 0 !important;
}
</style>
